import "./Step.scss";

import { ReactNode } from "react";
import { FCC } from "types";

interface StepProps {
  id: string;
  navigation?: ReactNode;
  subheadline?: string;
}

export const Step: FCC<StepProps> = ({
  id,
  subheadline,
  navigation,
  children,
}) => {
  return (
    <div data-testid={id} id={id} className="step-container">
      <div className="step">
        {subheadline && <p className="text-body-lg">{subheadline}</p>}
        {children}
      </div>
      {navigation}
    </div>
  );
};
